import { fork } from '../redux-saga';

import authSaga from '../auth/saga';
import { rootSaga as bookmarksSaga } from '../note/bookmarks/sagas';
import { rootSaga as beheerSaga } from '../admin/sagas';
import { rootSaga as categoriesSaga } from '../note/categories/sagas';
import categorySelectSaga from '../note/categorySelectPopup/sagas';
import noteParticipantSelectSaga from '../note/noteParticipantSelectPopup/sagas';
import { rootSaga as noteLocatorSaga } from '../note/locator/sagas';
import { rootSaga as notemenuSaga } from '../note/notemenu/sagas';
import { rootSaga as notesSaga } from '../note/notes/sagas';
import { rootSaga as notesSharedSaga } from '../note/noteshared/sagas';
import { rootSaga as selectionSaga } from '../note/selection/sagas';
import { rootSaga as statusDialogSaga } from '../note/statusDialog/sagas';
import { rootSaga as noteUISaga } from '../note/ui/sagas';
import { rootSaga as participantSaga } from '../participant/sagas';
import { rootSaga as emailSaga } from '../emailarchive/emails/sagas';
import { rootSaga as participantidSaga } from '../participantid/sagas';
import { rootSaga as userGroupSelectSaga } from '../usergroup/sagas';
import { rootSaga as noteChatSaga } from '../note/notechat/sagas';
import { rootSaga as questionAddresseeSaga } from '../questionaddressee/sagas';
import { rootSaga as questionsSaga } from '../note/question/sagas';

export function* storeRootSaga(): Iterable<any> {
    yield fork(authSaga);
    yield fork(beheerSaga);
    yield fork(noteUISaga);
    yield fork(selectionSaga);
    yield fork(notemenuSaga); 
    yield fork(notesSaga);
    yield fork(bookmarksSaga);
    yield fork(categoriesSaga);
    yield fork(noteLocatorSaga);
    yield fork(statusDialogSaga);
    yield fork(categorySelectSaga); 
    yield fork(participantSaga);
    yield fork(noteParticipantSelectSaga);
    yield fork(notesSharedSaga);    
    yield fork(emailSaga);
    yield fork(participantidSaga);
    yield fork(userGroupSelectSaga);     
    yield fork(noteChatSaga);    
    yield fork(questionAddresseeSaga);
    yield fork(questionsSaga);    
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/store/saga.tsx